
// Keyboard bindings for the editor
window.bindings = {
  tab: {key: 9, handler: function() { cursor_move('down') }},
  update_doc_text: { key: 'Enter', shiftKey: true, handler: function(range, context, event) { update_doc_text(); }  },
  save_all: { key: 'S', shiftKey: true, ctrlKey: true, handler: function(range, context, event) { save_all(); }  },
  move_up: { key: 219, shiftKey: true, ctrlKey: true, handler: function(range, context, event) { cursor_move('up'); }  },
  move_down: { key: 221, shiftKey: true, ctrlKey: true, handler: function(range, context, event) { cursor_move('down'); }  },
  copy_ref1: { key: 49, shiftKey: true, ctrlKey: true, handler: function(range, context, event) { copy_mt_keyb(1); }  },
  copy_ref2: { key: 50, shiftKey: true, ctrlKey: true, handler: function(range, context, event) { copy_mt_keyb(2); }  },
  copy_ref3: { key: 51, shiftKey: true, ctrlKey: true, handler: function(range, context, event) { copy_mt_keyb(3); }  },
  merge_document_texts: { key: 56, shiftKey: true, ctrlKey: true, handler: function(range, context, event) { merge_document_texts(); }  },
  split_document_texts: { key: 57, shiftKey: true, ctrlKey: true, handler: function(range, context, event) { split_document_texts(); }  },
};

// FUNCTION: Strip sides of text
window.strip = function(html) {
  var tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

// FUNCTION: replace punctuation
window.replace_punctuation = function(text) {
  text = text.replace(/&amp;/g,'&').replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/quot;/g,'"').replace(/&#39;/g,"'").replace(/&#x2F;/g,"/");
  return text;
}

// FUNCTION: Load Quills
window.prep_quills = function(src_keywords, targ_keywords, new_quills) {
  if (new_quills.length == 0) {
    var editors = $('[id^=editor_],[id^=find_editor_]');
  } else {
    var editors = new_quills;
  }

  for(var k=0; k <= editors.length-1; k++) {
    // initialize quills
    quills[editors[k].id.match(/\d+/)[0]] = new Quill(editors[k],
      {theme: 'snow', modules: {keyboard: {bindings: bindings}}
    });

    // add quill functionality when focused
    editors[k].firstChild.onfocus = function(e) {
      focus_id = e.target.parentNode.id.match(/\d+/)[0];
      quill = quills[focus_id];
      quill.setSelection(0,quill.getText().length-1);

      // remove focus from previous quill
      if (last_focus_id != null) {
        if ($('#row_'+last_focus_id)[0].querySelector("#source_text_broken")) {$('#row_'+last_focus_id)[0].querySelector("#source_text_broken").style.display = "none";}
        $('#row_'+last_focus_id)[0].querySelector("#source_text").style.display = "inherit";
        $('#row_'+last_focus_id)[0].querySelector("#mt1").style.display = "none";
        $('#row_'+last_focus_id)[0].querySelector("#mt2").style.display = "none";
        $('#row_'+last_focus_id)[0].querySelector("#mt3").style.display = "none";
        $('#row_'+last_focus_id)[0].querySelector("#mt1-2").style.display = "none";
        $('#row_'+last_focus_id)[0].querySelector("#mt2-2").style.display = "none";
        $('#row_'+last_focus_id)[0].querySelector("#mt3-3").style.display = "none";
        $('#row_'+last_focus_id)[0].classList.remove("document_row");
        $('#row_'+last_focus_id)[0].querySelector("#source").classList.remove("document_text_mt");
        last_focus_id_quill = quills[last_focus_id];
        rm_highlight_one(last_focus_id, last_focus_id_quill);
      }

      e.target.parentNode.parentNode.parentNode.querySelector("#source_text_broken").style.display = "inherit";
      e.target.parentNode.parentNode.parentNode.querySelector("#source_text").style.display = "none";
      e.target.parentNode.parentNode.parentNode.querySelector('#mt1').style.display = "flex";
      e.target.parentNode.parentNode.parentNode.querySelector('#mt2').style.display = "flex";
      e.target.parentNode.parentNode.parentNode.querySelector('#mt3').style.display = "flex";
      e.target.parentNode.parentNode.parentNode.querySelector('#mt1-2').style.display = "flex";
      e.target.parentNode.parentNode.parentNode.querySelector('#mt2-2').style.display = "flex";
      e.target.parentNode.parentNode.parentNode.querySelector('#mt3-3').style.display = "flex";
      e.target.parentNode.parentNode.parentNode.classList.add("document_row");
      e.target.parentNode.parentNode.parentNode.querySelector("#source").classList.add("document_text_mt");

      // add highlights to newly focused quill
      last_focus_id = e.target.parentNode.parentNode.parentNode.id.match(/\d+/)[0];
      last_focus_id_quill = quills[last_focus_id];
      rm_highlight_one(last_focus_id, last_focus_id_quill);
      highlight_one(focus_id, src_keywords, targ_keywords, quill, '#ffff89', '#c4ff89');

      // auto scroll sidebar preview document based on segment
      str = e.target.parentNode.parentNode.parentNode.querySelector("#source_text").textContent.trim();
      // 1. find all matches of the src (preview) text in the source
      matches = $(".source_text:contains("+str+")");
      pt = '';
      $.each( matches, function( i, value ) {
        if (e.target.parentNode.parentNode.parentNode.querySelector("#source_text") == value) {
          pt = i;
        }
      });
      // 2. find all matches of the src text in the preview and get the position
      idx = [];
      $("#sidebar_preview_iframe").contents().find("p:contains_without_newline("+str+")").each(function() {
        idx.push($(this).offset().top);
      });
      offset_top = idx[pt];
      $("#sidebar_preview_iframe").contents().scrollTop(offset_top-100);    //scroll to position
    }

    // remove focus from quill
    editors[k].firstChild.onblur = function(e) {
      doc_text_id = e.target.parentNode.id.match(/\d+/)[0];
      //update_doc_text(doc_text_id);

      if (e.relatedTarget != null && e.relatedTarget.className.match('source_text_broken') == null) {
        e.target.parentNode.parentNode.parentNode.querySelector("#source_text_broken").style.display = "none";
        e.target.parentNode.parentNode.parentNode.querySelector("#source_text").style.display = "block";
        e.target.parentNode.parentNode.parentNode.querySelector("#mt1").style.display = "none";
        e.target.parentNode.parentNode.parentNode.querySelector("#mt2").style.display = "none";
        e.target.parentNode.parentNode.parentNode.querySelector("#mt3").style.display = "none";
        e.target.parentNode.parentNode.parentNode.querySelector("#mt1-2").style.display = "none";
        e.target.parentNode.parentNode.parentNode.querySelector("#mt2-2").style.display = "none";
        e.target.parentNode.parentNode.parentNode.querySelector("#mt3-3").style.display = "none";
        e.target.parentNode.parentNode.parentNode.classList.remove("document_row");
        e.target.parentNode.parentNode.parentNode.querySelector("#source").classList.remove("document_text_mt");
      }
    }
  }
}


// FUNCTION: Prep Quill Highlights
window.prep_quill_highlights = function(src_keywords, targ_keywords) {
  var editors = $('[id^=editor_],[id^=find_editor_]');

  for(var k=0; k <= editors.length-1; k++) {
    // add quill functionality when focused
    editors[k].firstChild.onfocus = function(e) {
      focus_id = e.target.parentNode.id.match(/\d+/)[0];
      quill = quills[focus_id];
      quill.setSelection(0,quill.getText().length-1);

      // remove focus from previous quill
      if (last_focus_id != null) {
        if ($('#row_'+last_focus_id)[0].querySelector("#source_text_broken")) {$('#row_'+last_focus_id)[0].querySelector("#source_text_broken").style.display = "none";}
        $('#row_'+last_focus_id)[0].querySelector("#source_text").style.display = "inherit";
        $('#row_'+last_focus_id)[0].querySelector("#mt1").style.display = "none";
        $('#row_'+last_focus_id)[0].querySelector("#mt2").style.display = "none";
        $('#row_'+last_focus_id)[0].querySelector("#mt3").style.display = "none";
        $('#row_'+last_focus_id)[0].querySelector("#mt1-2").style.display = "none";
        $('#row_'+last_focus_id)[0].querySelector("#mt2-2").style.display = "none";
        $('#row_'+last_focus_id)[0].querySelector("#mt3-3").style.display = "none";
        $('#row_'+last_focus_id)[0].classList.remove("document_row");
        $('#row_'+last_focus_id)[0].querySelector("#source").classList.remove("document_text_mt");
        last_focus_id_quill = quills[last_focus_id];
        rm_highlight_one(last_focus_id, last_focus_id_quill);
      }

      // add highlights to newly focused quill
      last_focus_id = e.target.parentNode.parentNode.parentNode.id.match(/\d+/)[0];
      last_focus_id_quill = quills[last_focus_id];
      rm_highlight_one(last_focus_id, last_focus_id_quill);
      highlight_one(focus_id, src_keywords, targ_keywords, quill, '#ffff89', '#c4ff89');
    }
  }
}

// update particular editor
window.update_doc_text = function(doc_text_id) {
  if (doc_text_id) {doc_text_id = doc_text_id;}
  else {doc_text_id = document.activeElement.parentNode.parentNode.parentElement.id.match(/\d+/)[0];}
  if ($('#document_texts').is(":hidden") == true) { type1 = 'find' } else { type1 = 'default'};
  curr_row = $("#row_" + doc_text_id + "[type*='"+type1+"']");
  src = curr_row.find('#source_text').text();
  targ = curr_row.find('#editor_'+doc_text_id).text();
  targ_mt1 = curr_row.find('#mt1').find('[id^=targ_mt1_]').text();
  targ_mt2 = curr_row.find('#mt2').find('[id^=targ_mt2_]').text();
  targ_mt3 = curr_row.find('#mt3').find('[id^=targ_mt3_]').text();

  // get all merged segments where there is an empty row to remove
  empty_document_texts = [];
  i = true;
  while (i) {
    curr_row = curr_row.next();
    if (curr_row[0].style.display == "none") {
      empty_document_texts.push(curr_row[0].id.match(/\d+/)[0]);
    } else {
      i = false;
    }
  }
  empty_document_texts.forEach(
    function myFunction(doc_text_id) {
      $('#row_' + doc_text_id)[0].remove();
    }
  );

  $.ajax({
      type: 'POST',
      dataType: 'script',
      data: {
          src: strip(src),
          targ: strip(targ),
          targ_mt1: strip(targ_mt1),
          targ_mt2: strip(targ_mt2),
          targ_tm: strip(targ_mt3),
          empty_document_texts: JSON.stringify(empty_document_texts),
          auto_prop_forward: $('#auto_prop_forward_checkbox')[0].checked,
          auto_prop_backward: $('#auto_prop_backward_checkbox')[0].checked,
      },
      url: '/document_texts/'+doc_text_id,
      complete: function(data) {
      },
  }); 
}

// save all segments
window.save_all = function() {
  id_array = [];
  src_array = [];
  targ_array = [];
  targ_mt1_array = [];
  targ_mt2_array = [];
  targ_mt3_array = [];
  doc_id = $('#doc_id').text();
  rows = $('[type=default]');
  empty_document_texts = [];

  rows.each(function() {
    curr_row = $(this);
    id_array.push(curr_row[0].id.match(/\d+/)[0]);
    src = curr_row.find('#source_text').text();
    targ = curr_row.find('.editor').text();
    targ_mt1 = curr_row.find('#mt1').find('[id^=targ_mt1_]').text();
    targ_mt2 = curr_row.find('#mt2').find('[id^=targ_mt2_]').text();
    targ_mt3 = curr_row.find('#mt3').find('[id^=targ_mt3_]').text();
    src_array.push(strip(src));
    targ_array.push(strip(targ));
    targ_mt1_array.push(strip(targ_mt1));
    targ_mt2_array.push(strip(targ_mt2));
    targ_mt3_array.push(strip(targ_mt3));

    // get all merged segments where there is an empty row to remove
    if (curr_row[0].style.display == "none"){
      empty_document_texts.push(curr_row[0].id.match(/\d+/)[0]);
    }
  });

  empty_document_texts.forEach(
    function myFunction(doc_text_id) {
      $('#row_' + doc_text_id)[0].remove();
    }
  );

  $.ajax({
      type: 'POST',
      dataType: 'script',
      data: {        
          id_array: JSON.stringify(id_array),
          src_array: JSON.stringify(src_array),
          targ_array: JSON.stringify(targ_array),
          targ_mt1_array: JSON.stringify(targ_mt1_array),
          targ_mt2_array: JSON.stringify(targ_mt2_array),
          targ_mt3_array: JSON.stringify(targ_mt3_array),
          empty_document_texts: JSON.stringify(empty_document_texts),
          doc_id: doc_id,
      },
      url: '/document_texts/save_all',
      complete: function(data) {
      },
  });
}

// save all find results
window.save_all_find_results = function() {
  doc_id = $('#doc_id').text();
  id_array = [];
  src_array = [];
  targ_array = [];
  targ_mt1_array = [];
  targ_mt2_array = [];
  targ_mt3_array = [];
  rows = $('[type=find]');
  rows.each(function() {
    curr_row = $(this);
    id_array.push(curr_row[0].id.match(/\d+/)[0]);
    src = curr_row.find('#source_text').text();
    targ = curr_row.find('.editor').text();
    targ_mt1 = curr_row.find('#mt1').find('[id^=targ_mt1_]').text();
    targ_mt2 = curr_row.find('#mt2').find('[id^=targ_mt2_]').text();
    targ_mt3 = curr_row.find('#mt3').find('[id^=targ_mt3_]').text();
    src_array.push(strip(src));
    targ_array.push(strip(targ));
    targ_mt1_array.push(strip(targ_mt1));
    targ_mt2_array.push(strip(targ_mt2));
    targ_mt3_array.push(strip(targ_mt3));
  });

  empty_document_texts = [];
  i = true;
  while (i) {
    curr_row = curr_row.next();
    if (curr_row[0].style.display == "none") {
      empty_document_texts.push(curr_row[0].id.match(/\d+/)[0]);
    } else {
      i = false;
    }
  }
  empty_document_texts.forEach(
    function myFunction(doc_text_id) {
      $('#row_' + doc_text_id)[0].remove();
    }
  );

  $.ajax({
      type: 'POST',
      dataType: 'script',
      data: {
          doc_id: doc_id,
          id_array: JSON.stringify(id_array),
          src_array: JSON.stringify(src_array),
          targ_array: JSON.stringify(targ_array),
          targ_mt1_array: JSON.stringify(targ_mt1_array),
          targ_mt2_array: JSON.stringify(targ_mt2_array),
          targ_mt3_array: JSON.stringify(targ_mt3_array),
          empty_document_texts: JSON.stringify(empty_document_texts),
      },
      url: '/document_texts/save_all',
      complete: function(data) {
      },
  });
}

// copy MT reference to the editor (mouse click)
window.copy_mt = function(e) {
  var mt_idx = e.path[1].id.match(/\d+/)[0];
  var doc_text_id = e.path[2].id.match(/\d+/)[0];
  targ = $("#targ_mt"+mt_idx+"_"+doc_text_id).text();
  curr_row = $('#row_' + doc_text_id);
  if (curr_row[0].getAttribute('type') == 'find') {
    quill = find_quills[doc_text_id];
  } else {
    quill = quills[doc_text_id];
  }
  targ = replace_punctuation(targ);
  quill.setText(targ);
  if (quill) {
    quill.focus();
    quill.setSelection(0,quill.getText().length-1);
  }
}

// copy MT reference to the editor (keyboard hotkey)
window.copy_mt_keyb = function(mt_idx) {
  if ($('#document_texts').is(":hidden") == true) { type1 = 'find' } else { type1 = 'default'};
  var doc_text_id = document.activeElement.parentNode.parentNode.parentElement.id.match(/\d+/)[0];
  targ = $("#targ_mt"+mt_idx+"_"+doc_text_id).text();
  curr_row = $("#row_" + doc_text_id + "[type*='"+type1+"']");
  if (curr_row[0].getAttribute('type') == 'find') {
    quill = find_quills[doc_text_id];
  } else {
    quill = quills[doc_text_id];
  }
  targ = replace_punctuation(targ);
  quill.setText(targ);
  if (quill) {
    quill.focus();
    quill.setSelection(0,quill.getText().length-1);
  }
}

// move cursor up and down between editors
window.cursor_move = function(direction) {
  var doc_text_id = document.activeElement.parentNode.parentNode.parentElement.id.match(/\d+/)[0];
  if ($('#document_texts').is(":hidden") == true) { type1 = 'find' } else { type1 = 'default'};
  curr_row = $("#row_" + doc_text_id + "[type*='"+type1+"']");
  i = true;
  if (direction == 'down') {
    if (curr_row[0].getAttribute('value') == 1){return;}
    while (i) {
      curr_row = curr_row.nextAll('.document_text:first');
      if (curr_row.length == 0){i = false;}
      else if (curr_row[0].style.display == "none"){}
      else{i = false;}
    }
    elem = curr_row.find('.editor')[0];
  }
  if (direction == 'up') {
    if (curr_row[0].getAttribute('value') == -1){return;}
    while (i) {
      curr_row = curr_row.prevAll('.document_text:first');
      if (curr_row.length == 0){i = false;}
      else if (curr_row[0].style.display == "none") {}
      else{i = false;}
    }
    elem = curr_row.find('.editor')[0];
  }
  if (elem == null) {} else {
    if (curr_row[0].getAttribute('type') == 'find') {
      quill = find_quills[elem.id.match(/\d+/)[0]];
    } else {
      quill = quills[elem.id.match(/\d+/)[0]];
    }
    quill.focus();
    quill.setSelection(0,quill.getText().length-1);

    const yCoordinate = elem.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -400;
    window.scrollTo({
        top: yCoordinate + yOffset,
        behavior: 'smooth'
    });
  }
}


// merge two rows (source, targ, MT reference, etc..)
window.merge_document_texts = function() {
  var doc_text_id = document.activeElement.parentNode.parentNode.parentElement.id.match(/\d+/)[0];
  if ($('#document_texts').is(":hidden") == true) { type1 = 'find' } else { type1 = 'default'};
  next_row = $("#row_" + doc_text_id + "[type*='"+type1+"']");
  if (next_row[0].getAttribute('value') == 1){return;}

  i = true;
  while (i) {
    next_row = next_row.next();
    if (next_row[0].getAttribute('value') == null) {return;}
    if (next_row[0].style.display != "none"){
      next_row[0].style.display = "none";
      i = false;
    }
  }

  quill = quills[doc_text_id];
  btm_source = next_row.find('#source_text').text();
  btm_source_broken = next_row.find('#source_text_broken').text();
  btm_editor = next_row.find('.ql-editor').text();
  btm_mt1 =    next_row.find('#mt1').find('[id^=targ_mt1_]').text();
  btm_mt2 =    next_row.find('#mt2').find('[id^=targ_mt2_]').text();
  btm_mt3 =    next_row.find('#mt3').find('[id^=targ_mt3_]').text();

  curr_row = $('#row_' + doc_text_id);
  targ =       curr_row.find('.ql-editor').text();
  targ_mt1 = curr_row.find('#mt1').find('[id^=targ_mt1_]').text();
  targ_mt2 = curr_row.find('#mt2').find('[id^=targ_mt2_]').text();
  targ_mt3 = curr_row.find('#mt3').find('[id^=targ_mt3_]').text();
  curr_row.find('#source_text').html(curr_row.find('#source_text').text().trim()+" "+btm_source.trim());
  curr_row.find('#source_text_broken').html(curr_row.find('#source_text_broken').text()+" "+btm_source_broken);
  quill.setText( curr_row.find('.ql-editor').text()+" "+btm_editor );
  curr_row.find('#mt1').find('[id^=targ_mt1_]').html(curr_row.find('#mt1').find('[id^=targ_mt1_]').text()+" "+btm_mt1);
  curr_row.find('#mt2').find('[id^=targ_mt2_]').html(curr_row.find('#mt2').find('[id^=targ_mt2_]').text()+" "+btm_mt2);
  curr_row.find('#mt3').find('[id^=targ_mt3_]').html(curr_row.find('#mt3').find('[id^=targ_mt3_]').text()+" "+btm_mt3);

  curr_row = $('#row_' + doc_text_id);

  if (quill == null) {} else {
    setTimeout(function() {
      quill.focus();
      quill.setSelection(0,quill.getText().length-1);
    }, 150);
  }
}

// split two rows based on if they marged before
window.split_document_texts = function() {
  var doc_text_id = document.activeElement.parentNode.parentNode.parentElement.id.match(/\d+/)[0];
  if ($('#document_texts').is(":hidden") == true) { type1 = 'find' } else { type1 = 'default'};
  curr_row = $("#row_" + doc_text_id + "[type*='"+type1+"']");
  if (curr_row[0].getAttribute('value') == 1) {return;}

  i = true;
  inc = 0
  while (i) {
    curr_row = curr_row.next();
    // if curr_row is last row (without hidden) it should return
    // if (curr_row.next("div[style='display: none;'][id^=row_]").length < 1){return;}
    if (curr_row[0].style.display != "none") {
      curr_row = curr_row.prev();
      if (inc > 0){curr_row[0].style.display = "flex";}
      i = false;
    }
    inc+=1;
  }

  if (inc > 1){
    btm_source = curr_row.find('#source_text').text();
    btm_source_broken = curr_row.find('#source_text_broken').text();
    btm_mt1 =    curr_row.find('#mt1').find('[id^=targ_mt1_]').text();
    btm_mt2 =    curr_row.find('#mt2').find('[id^=targ_mt2_]').text();
    btm_mt3 =    curr_row.find('#mt3').find('[id^=targ_mt3_]').text();

    curr_row = $('#row_' + doc_text_id);
    new_source = replaceLast(" "+btm_source.trim(),'', curr_row.find('#source_text').text());
    new_source_broken = replaceLast(" "+btm_source_broken.trim(),'', curr_row.find('#source_text_broken').text());
    new_mt1 = replaceLast(" "+btm_mt1,'', curr_row.find('#mt1').find('[id^=targ_mt1_]').text());
    new_mt2 = replaceLast(" "+btm_mt2,'', curr_row.find('#mt2').find('[id^=targ_mt2_]').text());
    new_mt3 = replaceLast(" "+btm_mt3,'', curr_row.find('#mt3').find('[id^=targ_mt3_]').text());

    curr_row.find('#source_text').text(new_source);
    curr_row.find('#source_text_broken').text(new_source_broken);
    curr_row.find('#mt1').find('[id^=targ_mt1_]').text(new_mt1);
    curr_row.find('#mt2').find('[id^=targ_mt2_]').text(new_mt2);
    curr_row.find('#mt3').find('[id^=targ_mt3_]').text(new_mt3);

    quill = quills[doc_text_id];
    if (quill == null) {} else {
      quill.focus();
      quill.setSelection(0,quill.getText().length-1);
    }
  }
};

// FUNCTION: replace the last occurence of word from string
window.replaceLast = function(find, replace, string) {
    var lastIndex = string.lastIndexOf(find);
    if (lastIndex === -1) {
        return string;
    }
    var beginString = string.substring(0, lastIndex);
    var endString = string.substring(lastIndex + find.length);
    return beginString + replace + endString;
}

// FUNCTION: replace the text
window.replaceText = function(test) {
  let replaceText = test.dataset.val;
  let res = replaceAll(replaceText)
  if (res) {
    delta.ops[0].insert = res
    quill.setContents([
      { insert: res }
    ]);
  }
};

window.replaceAll = function(rt) {

  while (fullTextString.indexOf(text) > -1) {
    var re = new RegExp(text,"g");
    fullTextString = fullTextString.replace(re, rt);
  }
  return fullTextString;
};

// FUNCTION: highlight one quill
window.highlight_one = function(focus_id, src_keywords, targ_keywords, quill, src_color, targ_color) {
  src_keywords = src_keywords.filter(function (el) {return el != null && el != "";});
  targ_keywords = targ_keywords.filter(function (el) {return el != null && el != "";});
  src_keywords.sort(function(a, b){ return a.length - b.length; });
  targ_keywords.sort(function(a, b){ return a.length - b.length; });

  new_src_keywords = []
  src_keywords.forEach(function (item, index) {
    item = replace_punctuation(item);
    if (isInArray(item, new_src_keywords) == false) {
      new_src_keywords.push(item);
      if (item.match(/[\‘\’“\”\'\"]/)) {
        new_src_keywords.push(item.replace(/\'(.*)\'/g,"‘\$1’").replace(/\"(.*)\"/g,"“\$1”"));
        new_src_keywords.push(item.replace(/’/g,"'").replace(/‘/g,"'").replace(/“/g,'"').replace(/”/g,'"'));
      }
    }
  });

  new_targ_keywords = []
  targ_keywords.forEach(function (item, index) {
    item = replace_punctuation(item);
    if (isInArray(item, new_targ_keywords) == false) {
      new_targ_keywords.push(item);
      if (item.match(/[\‘\’“\”\'\"]/)){
        new_targ_keywords.push(item.replace(/\'(.*)\'/g,"‘\$1’").replace(/\"(.*)\"/g,"“\$1”"));
        new_targ_keywords.push(item.replace(/’/g,"'").replace(/‘/g,"'").replace(/“/g,'"').replace(/”/g,'"'));
      }
    }
  });

  var options = {
      "className": "keyword", "exclude": [], "separateWordSearch": false, "accuracy": "exactly", "diacritics": true, "synonyms": {}, "acrossElements": true, "caseSensitive": false, "ignoreJoiners": false, "ignorePunctuation": []
  };
  var options_2 = {
    "className": "keyword_2", "exclude": [], "separateWordSearch": false, "accuracy": "exactly", "diacritics": true, "synonyms": {}, "acrossElements": true, "caseSensitive": false, "ignoreJoiners": false, "ignorePunctuation": []
  };

  // highlight non-quill texts 
  $("#row_"+focus_id).find(".source_text").mark(new_src_keywords, options);
  $("#row_"+focus_id).find(".source_text_broken").mark(new_src_keywords, options);
  $("#row_"+focus_id).find(".mt_reference").mark(new_src_keywords, options);
  $("#row_"+focus_id).find(".source_text_broken").mark(new_targ_keywords, options_2);
  $("#row_"+focus_id).find(".source_text").mark(new_targ_keywords, options_2);
  $("#row_"+focus_id).find(".mt_reference").mark(new_targ_keywords, options_2);
    
  // highlight quill editor with src_keywords
  text = quill.getText();  
  for (var i = 0; i < new_src_keywords.length; i++) {
    indices = getIndicesOf(new_src_keywords[i], text, false);
    for (var j = 0; j < indices.length; j++) {                       
      quill.formatText(indices[j], new_src_keywords[i].length, {'padding': '0.1em', 'background-color': src_color, 'border': '1px solid #f2f2f2', 'color': 'black'});
      quill.removeFormat(indices[j]+new_src_keywords[i].length,1);      
    }                    
  }

  // highlight quill editor with targ_keywords
  for (var i = 0; i < new_targ_keywords.length; i++) {
    indices = getIndicesOf(new_targ_keywords[i], text, false);
    for (var j = 0; j < indices.length; j++) {                       
      quill.formatText(indices[j], new_targ_keywords[i].length, {'padding': '0.1em', 'background-color': targ_color, 'border': '1px solid #f2f2f2', 'color': 'black'});
      quill.removeFormat(indices[j]+new_targ_keywords[i].length,1);    
    }                    
  }
};

// FUNCTION: remove highlight from one segment row
window.rm_highlight_one = function(focus_id, quill) {    
  $("#row_"+focus_id).find('.source_text').unmark();
  $("#row_"+focus_id).find('.source_text_broken').unmark();
  $("#row_"+focus_id).find('.document_text_mt').unmark();
  text = quill.getText();
  quill.removeFormat(0, text.length-1);
};

// FUNCTION: highlight all find quills
window.find_highlight = function(src_keywords, some_quills, src_color) {  
  src_keywords = src_keywords.filter(function (el) {return el != null && el != "";});
  
  new_src_keywords = []
  src_keywords.forEach(function (item, index) {
    item = replace_punctuation(item);
    if (isInArray(item, new_src_keywords) == false) {
      new_src_keywords.push(item);
      if (item.match(/[\‘\’“\”\'\"]/)){
        new_src_keywords.push(item.replace(/\'(.*)\'/g,"‘\$1’").replace(/\"(.*)\"/g,"“\$1”"));
        new_src_keywords.push(item.replace(/’/g,"'").replace(/‘/g,"'").replace(/“/g,'"').replace(/”/g,'"'));
      }      
    }
  });

  var options_3 = {
    "className": "keyword_3", "exclude": [], "separateWordSearch": false, "accuracy": "exactly", "diacritics": true, "synonyms": {}, "acrossElements": true, "caseSensitive": false, "ignoreJoiners": false, "ignorePunctuation": []
  };

  $(".find_source_text").unmark();
  $(".find_document_text_mt").unmark();
  $(".find_source_text").mark(new_src_keywords, options_3);
  $(".find_document_text_mt").mark(new_src_keywords, options_3);

  Object.keys(some_quills).forEach(function (key) {
    quill = some_quills[key];
    text = quill.getText();
    quill.removeFormat(0, text.length-1);

    for (var i = 0; i < new_src_keywords.length; i++) {
      indices = getIndicesOf(new_src_keywords[i], text, false);
      for (var j = 0; j < indices.length; j++) {
        quill.formatText(indices[j], new_src_keywords[i].length, {'padding': '0.1em', 'background-color': src_color, 'border': '1px solid #f2f2f2', 'color': 'black'});
        quill.removeFormat(indices[j]+new_src_keywords[i].length,1);
      }
    }

  });
};

// get indices of all substring matches on string
window.getIndicesOf = function(searchStr, str, caseSensitive) {
    var searchStrLen = searchStr.length;
    if (searchStrLen == 0) {
        return [];
    }
    var startIndex = 0, index, indices = [];
    if (!caseSensitive) {
        str = str.toLowerCase();
        searchStr = searchStr.toLowerCase();
    }
    while ((index = str.indexOf(searchStr, startIndex)) > -1) {
        indices.push(index);
        startIndex = index + searchStrLen;
    }
    return indices;
};


// either show find results or jump between matches and select it in the quill
window.find_keyword = '';
window.find_text = function(doc_id) {
  keyword = $('#find')[0].value;
  $('.document_texts').infinitePages('pause');
  if (find_keyword != keyword) {
    find_keyword = keyword;
    $('#find_and_replace').show();
    $('#document_texts').hide();
    $.ajax({
      type: 'GET',
      dataType: 'script',
      data: {
        keyword: keyword,
        search_src: $('#source_checkbox')[0].checked,
        search_targ: $('#target_checkbox')[0].checked,
        case_sensitive: $('#case_checkbox')[0].checked
      },
      url: '/documents/find_texts/'+doc_id,
    });
  } else {
    find_keyword_array = get_matches(keyword);
    find_keyword_array_idx += 1;
    if (find_keyword_array.length > 0) {
      if (find_keyword_array_idx >= find_keyword_array.length) {find_keyword_array_idx = 0;}
      quill = find_quills[find_keyword_array[find_keyword_array_idx][0]];
      if (quill) {
        quill.setSelection(find_keyword_array[find_keyword_array_idx][1],keyword.length);
      }
    }
  }
}

// replace the selected keyword with the find/replace params
window.replace_text = function(doc_id) {
  keyword = $('#find')[0].value;
  replace_keyword = $('#replace')[0].value;
  find_keyword_array = get_matches(keyword);
  if (keyword && find_keyword_array.length > 0) {
    find_text(doc_id);
    quill = find_quills[find_keyword_array[find_keyword_array_idx][0]];
    if (quill) {
      range = quill.getSelection();
      if (range) {
        current_text = quill.getText(range.index, range.length);
        if ($('#case_checkbox')[0].checked == false) {
          current_text = current_text.toLowerCase();
          keyword = keyword.toLowerCase();
        }
        if (current_text == keyword) {
          quill.deleteText(range.index, range.length);
          quill.insertText(range.index, replace_keyword);
          find_keyword_array_idx -= 1;
          $('#find_results_len').html(find_keyword_array.length - 1);
          find_text(doc_id);
        } else {
          find_text(doc_id);
        }
      }
      else {
        find_text(doc_id);
      }
    }
  } else if (keyword) {
    find_text(doc_id);
  }
}

// iterate through all find matches and do a replace
window.replace_all_text = function(doc_id) {
  keyword = $('#find')[0].value;
  if (keyword && find_keyword_array.length > 0) {
    find_keyword_array = get_matches(keyword);
    //find_keyword_array.push(find_keyword_array[0]); // duplicate first item at the end of array
    find_keyword_array.forEach(function (item, index) {
      replace_text(doc_id);
    });
  }
  else if (keyword) {
    find_text(doc_id);
  } 
}

// get matches for word find
window.get_matches = function(keyword) {
  find_keyword_array = [];
  keys = Object.keys(find_quills);
  keys.forEach(function (item, index) {
    quill = find_quills[item]
    full_text = quill.getText();

    case_sensitive = $('#case_checkbox')[0].checked;
    indices = getIndicesOf(keyword, full_text, case_sensitive);
    for (var j = 0; j < indices.length; j++) {
      find_keyword_array.push([item,indices[j]])
    }
  });
  return find_keyword_array;
}

// FUNCTION: save & exist from editor
window.exit_find_replace = function() {
  $('#find_and_replace').hide();
  $('#document_texts').show();
  $('.document_texts').infinitePages('resume');
  find_keyword = '';
}
